import {AsyncPipe} from "@angular/common";
import {Component, OnDestroy, OnInit} from '@angular/core';
import {catchError, EMPTY, Observable, of, Subject, takeUntil, tap} from "rxjs";
import {AvatarPipe} from "@app/shared/pipes/avatar.pipe";
import {Address, User} from "@app/core/models/java.model";
import {HttpErrorResponse} from "@angular/common/http";
import {AddressService} from "@client/service/address.service";
import {ToastrService} from "ngx-toastr";
import {add} from "lodash";
import {AuthenticationService} from "@app/authentication";


@Component({
  selector: 'ms-admin-account',
  standalone: true,
  imports: [AsyncPipe, AvatarPipe],
  templateUrl: './admin-account.component.html',
  styleUrl: './admin-account.component.scss'
})
export class AdminAccountComponent implements OnInit, OnDestroy {
  user$!: Observable<User>;
  address?: Address;
  protected readonly add = add;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly authService: AuthenticationService, private addressService: AddressService, private toastr: ToastrService) {
  }

  ngOnInit() {
    this.user$ = this.authService.getCurrentUser();
  }

  getUserName() {
    return this.authService.getUserName();
  }

  getUserFullName() {
    return this.authService.getUserName();
  }

  loadDefaultAddress(): void {

    this.addressService.findDefault()
      .pipe(takeUntil(this.destroy$),
        tap(address => {
          if (address) {
            this.address = address;
          }
        }), catchError((err: HttpErrorResponse) => {

          if (err.status === 404) {
            return of(null); // No default address found, this is not an error
          }
          this.toastr.error("Erreur lors de la récupération de l'adresse.");
          return EMPTY;
        })).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
